export function isPlainClick(event: React.MouseEvent<any> | MouseEvent) {
  if (event.metaKey || event.altKey || event.shiftKey || event.ctrlKey) {
    return false;
  }

  return true;
}

export function isLeftClick(event: React.MouseEvent<any>) {
  if (event.hasOwnProperty('buttons') && event.buttons) {
    return event.buttons === 1;
  }
  const button = event.nativeEvent.which || event.button;
  return button < 2;
}

export enum MouseButton {
  Other = -1,
  Main = 0,
  Auxiliary = 1,
  Secondary = 2,
}

export function getClickType(event: MouseEvent): MouseButton {
  const buttonClicked = event.which - 1 || event.button;

  if (buttonClicked < 0 || buttonClicked > 2) {
    return MouseButton.Other;
  }

  return buttonClicked;
}
